<div class="master-modal" role="dialog">
  <div class="modal-dialog">
    <!-- Modal content-->
    <div class="modal-content">
      <!-- Modal-Header -->
      <div class="modal-header">
        <h4 class="modal-title"> Account Pay </h4>
        <div class="modal_close_btn">
          <span (click)="closeDialog('no')" class="modal-close"><i class="material-icons">close</i></span>
        </div>
      </div>
      <form class="form-section" [formGroup]="supplierAccountRequestPayForm" (ngSubmit)="addUpdateSupplierAccount()">
        <!-- Modal content-->
      <perfect-scrollbar class="modal-body-scrollbar">
        <div mat-dialog-content>
          <div class="modal-body">
              <!-- Company Name-INPUT -->
              <div class="custom-form-group">
                <label class="custom-label" for="">Select Company <span class="star">*</span></label>
                <div class="custom-form-control">
                  <mat-form-field appearance="outline">
                    <mat-select formControlName="supplier_id" placeholder="Select company">
                      <mat-option *ngFor="let singleSupplier of dentalSupplierList"
                      [value]="singleSupplier.id">
                        {{singleSupplier.name}}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="supplier_id.invalid && ( supplier_id.dirty || supplier_id.touched )">
                      <span>Please select supplier</span>
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <!-- Company Name-INPUT -->
              <div class="custom-form-group">
                <label class="custom-label" for=""> Name <span class="star">*</span></label>
                <div class="custom-form-control">
                  <mat-form-field appearance="outline">
                    <input matInput placeholder="Enter name" formControlName="name" />
                    <mat-error *ngIf="name.invalid && ( name.dirty || name.touched )">
                      <span>Please provide a valid Account Number</span>
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>

              <!-- Company Name-INPUT -->
              <div class="custom-form-group">
                <label class="custom-label" for=""> Email <span class="star">*</span></label>
                <div class="custom-form-control">
                  <mat-form-field appearance="outline">
                    <input matInput placeholder="Enter email" formControlName="email" />
                    <mat-error *ngIf="email.invalid && ( email.dirty || email.touched )">
                      <span>Please provide a valid Account Number</span>
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>

              <!-- Company Name-INPUT -->
              <div class="custom-form-group">
                <label class="custom-label" for=""> Phone <span class="star">*</span></label>
                <div class="custom-form-control">
                  <mat-form-field appearance="outline">
                    <input matInput placeholder="Enter phone" formControlName="phone" />
                    <mat-error *ngIf="phone.invalid && ( phone.dirty || phone.touched )">
                      <span>Please provide a valid phone </span>
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>




          </div>
        </div>
      </perfect-scrollbar>
      <!-- Modal-Footer -->
      <div class="modal-footer">
        <div mat-dialog-actions class="modal_footer">
          <button type="button" mat-button (click)="closeDialog('no')" class="modal-cancel-btn modal-footer-btn">
            <span> Cancel </span>
          </button>
          <button type="submit" mat-button class="modal-save-btn global-btn">
            <span> Submit </span>
          </button>
        </div>
      </div>

    </form>

    </div>
  </div>
</div>
